import Vue from 'vue';
import VueMultiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.component('multiselect', VueMultiselect);

Vue.use(VueMultiselect);

